import type { ReactNode } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack } from '@mui/material';
import { ApiErrorAlert } from '../../../components/ApiErrorAlert';

/**
 * Shared dialog chrome for all three demand types' create/edit forms — keeps the three
 * pages (BusDemand/VisaDemand/GroupTicketDemand) visually consistent without forcing their
 * genuinely-different DTOs into one generic form component.
 */
export function DemandFormDialog({
  open,
  title,
  onClose,
  onSubmit,
  submitting,
  error,
  children,
  submitLabel = 'Kaydet',
}: {
  open: boolean;
  title: string;
  onClose: () => void;
  onSubmit: () => void;
  submitting: boolean;
  error: unknown;
  children: ReactNode;
  submitLabel?: string;
}) {
  return (
    <Dialog open={open} onClose={() => !submitting && onClose()} maxWidth="sm" fullWidth>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Stack spacing={2} sx={{ mt: 1 }}>
          {children}
          <ApiErrorAlert error={error} />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={submitting}>
          Vazgeç
        </Button>
        <Button onClick={onSubmit} variant="contained" disabled={submitting}>
          {submitting ? 'Kaydediliyor…' : submitLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
